import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";

// scan start/stop button
// disabled: the camera is not ready yet, so a scan cannot be started.
export const CaptureButton = ({
  recording,
  active,
  count,
  countingDown,
  disabled,
  onClick,
}) => (
  <Box
    component="button"
    type="button"
    aria-label={
      countingDown ? "Cancel countdown" : recording ? "Stop scan" : "Start scan"
    }
    onClick={onClick}
    disabled={disabled}
    sx={{
      position: "relative",
      width: 72,
      height: 72,
      borderRadius: "50%",
      backgroundColor: "rgba(0,0,0,0.2)",
      border: "2px solid rgba(255,255,255,0.9)",
      cursor: disabled ? "default" : "pointer",
      p: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    {/* inner shape: circle when idle, rounded square while recording */}
    <Box
      sx={{
        width: recording ? 40 : 56,
        height: recording ? 40 : 56,
        borderRadius: recording ? "8px" : "50%",
        backgroundColor: active ? "primary.main" : "grey.500",
        transition: "all 0.4s ease",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {countingDown ? (
        // cross icon — tapping cancels the countdown
        <svg width="28" height="28" viewBox="0 0 24 24">
          <path
            stroke="#fff"
            strokeWidth="2.5"
            strokeLinecap="round"
            d="M6 6l12 12M18 6L6 18"
          />
        </svg>
      ) : (
        recording && (
          <Typography sx={{ color: "#fff", fontWeight: "bold" }}>
            {count}
          </Typography>
        )
      )}
    </Box>
  </Box>
);

CaptureButton.propTypes = {
  recording: PropTypes.bool.isRequired,
  active: PropTypes.bool.isRequired,
  count: PropTypes.number.isRequired,
  countingDown: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};
